import { useAiBuilderChatCopy } from '../hooks/useAiBuilderChatCopy';
import { type AiBuilderChatEntry } from '../store/types';
import { type AiBuilderQuestionState, getAiBuilderEntryGuide, getAiBuilderQuestionStateLead } from '../utils/aiBuilderWelcomePolicy';
import { type AiBuilderBuilderContext } from '../utils/types';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
export const AiBuilderIntroMessage = ({
  builderContext,
  entryIntent,
  questionState
}: {
  builderContext: AiBuilderBuilderContext;
  entryIntent: AiBuilderChatEntry;
  questionState: AiBuilderQuestionState;
}) => {
  const copy = useAiBuilderChatCopy();
  const {
    userName
  } = builderContext;
  const trimmedUserName = userName.trim();
  const greetingText = trimmedUserName ? copy.intro.greetingWithName(trimmedUserName) : copy.intro.greetingWithoutName;
  const greetingNameSuffix = trimmedUserName && greetingText.startsWith(trimmedUserName) ? greetingText.slice(trimmedUserName.length) : null;
  const questionStateLead = getAiBuilderQuestionStateLead({
    builderContext,
    copy,
    questionState
  });
  const entryGuide = getAiBuilderEntryGuide(entryIntent, copy);
  const introText = `${greetingText}\n\n${questionStateLead}\n${entryGuide}`;
  return <AiBuilderChatMessageAI data-sentry-element="AiBuilderChatMessageAI" data-sentry-component="AiBuilderIntroMessage" data-sentry-source-file="AiBuilderIntroMessage.tsx">
      <AiBuilderChatMessageAI.Body className="flex-col gap-3xs text-body-lg-medium text-default" data-sentry-element="unknown" data-sentry-source-file="AiBuilderIntroMessage.tsx">
        {trimmedUserName && greetingNameSuffix !== null ? <p>
            <strong className="font-bold">{trimmedUserName}</strong>
            {greetingNameSuffix}
          </p> : <p>{greetingText}</p>}
        <p>{questionStateLead}</p>
        <p>{entryGuide}</p>
      </AiBuilderChatMessageAI.Body>
      <AiBuilderChatMessageAI.Copy text={introText} data-sentry-element="unknown" data-sentry-source-file="AiBuilderIntroMessage.tsx" />
    </AiBuilderChatMessageAI>;
};